module.exports = __webpack_public_path__ + "img/teddy.be5030ca.webp";